import { AuthService } from '@/services/auth-service.js'
import { checkError } from '@/config/errors.js'

export default {
  namespaced: true,

  state: {
    posts: [],
    token: localStorage.getItem('access_token') || null,
    error: null,
    loader: false,
    profile:  [],
    drawer: true,
    username: '',
    password: '',
    role: localStorage.getItem('role') || null,

    permissions:localStorage.getItem('permissions') || [],
    MenuList: JSON.parse(localStorage.getItem('Menu')) || [],
    notificationDrawer: false    
  },

  mutations: {
    setToken(state, payload) {
      state.token = payload;
    },
    setUsername(state, payload) {
      state.username = payload;
    },
    setPassword(state, payload) {
      state.password = payload;
    },
    setLoader(state, payload) {
      state.loader = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setClearError(state) {
      state.error = null;
    },
    destroyToken(state) {
      state.token = null;
    },
    setProfile(state, payload) {
      state.profile = payload;
    },
    setClearProfile(state) {
      state.profile = [];
    },
    setDrawer(state, payload) {
      state.drawer = payload;
    },
    setNotificationDrawer(state, payload) {
      state.notificationDrawer = payload;
    },
    setRole(state, payload) {
      state.role = payload;
    }, 
    setPermissions(state, payload) {
      state.permissions = payload;
    }, 
    setClearPermissions(state) {
      state.permissions = [];
    },   
    setMenu(state, payload) {
      state.MenuList = payload;
    },  
  },

  actions: {

    setUsername({commit}, payload) {
      commit('setUsername', payload);
    },

    setPassword({commit}, payload) {
      commit('setPassword', payload);
    },

    retrieveToken({ commit }, credentials) {
      commit('setLoader', true);
      commit('setClearError');

      let data = {
        username: credentials.username,
        password: credentials.password
      };
      return new Promise((resolve) => {
        AuthService.login(data)
          .then(response => {
            commit('setLoader', false);                        
            const token = response.data.token           
            localStorage.setItem('access_token', token);
            localStorage.setItem('userId', response.data?.user?.uuid || null);
            localStorage.setItem('role', response.data?.roles?.[0]?.name || null);
            commit('setRole', response.data?.roles?.[0]?.name || null);      
            commit('setToken', token);
            
            localStorage.removeItem('cp_activity_page');
            localStorage.removeItem('project_page');
            
            resolve(response)
          })
          .catch(error => {

            let errorData = error?.response?.data;
           
            if (errorData.error === "Invalid credentials") {
              commit('setError', ['Username or Password is wrong']);
            }
            else if (errorData.error === "Member not active!") {
              commit('setError', ['Member not active!']);
            }
            else if (errorData.error === "invalid_request") {
              commit('setError', ['Please enter username and password']);
            }
            else if (errorData.code === 10) {
              commit('setError', ['Username or Password is wrong']);
            }
            else {
              let errorOutput = checkError.errorFormatting(errorData);
              commit('setError', errorOutput);
            }
            commit('setLoader', false);
            localStorage.removeItem('access_token')
            commit('setToken', null);
            commit('setRole', null);     
           

          })
      })
    },

    clearError({ commit }) {
      commit('setClearError');
    },

    changeDrawer({ commit }, value) {
      commit('setDrawer', value);
    },

    changeNotificationDrawer({ commit }, value) {
      commit('setNotificationDrawer', value);
    },    

    destroyToken(context) {
      context.commit('setClearError');
      return new Promise((resolve) => {        
        context.commit('destroyToken');
        context.commit('setToken', null);          
        context.commit('setLoader', false);   
        context.commit('setRole', null);      
        localStorage.removeItem('role');
        localStorage.removeItem('roles');
        localStorage.removeItem('userId');
        localStorage.removeItem('permissions');
        localStorage.removeItem('Menu');
        context.commit('setProfile', []); 
        context.commit('setClearPermissions');      
        AuthService.logout()
          .then(response => {    
            localStorage.removeItem('access_token');    
            resolve(response)
          })
          .catch(error => {
            context.commit('setLoader', false);
            context.commit('setError', error.response.data);
            localStorage.removeItem('access_token');
            this.$router.push("/login");
          })
      })

    },
    register({ commit }, data) {
      commit('setLoader', true);
      commit('setClearError');
      data = {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        school: data.school,
        password: data.password,
        district: data.district,
        type: data.type,
        mobile: data.mobile,
        password_confirmation: data.password_confirmation,
      }
      return new Promise((resolve) => {
        AuthService.register(data)
          .then(response => {
            resolve(response);
            commit('setLoader', false);
          })
          .catch(error => {
            commit('setLoader', false);
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            commit('setError', errorOutput);
          })
      })
    },

    getProfile (context ){
      context.commit('setClearError');
      context.commit('setLoader', true);
      return new Promise((resolve) => {
        AuthService.getProfile()
          .then(response => {                       
            context.commit('setLoader', false);          
            context.commit('setProfile', response?.data.data);      
            resolve(response)
          })
          .catch(error => {
            context.commit('setLoader', false);
            context.commit('setError', error.response.data);
            context.commit('setProfile', []);  
          })
      })
    },

    roleSet({ commit }, data ){     
      commit('setLoader', true);
      return new Promise((resolve) => {      
        localStorage.setItem('role',  data.role.name || null);
        localStorage.setItem('permissions',  JSON.stringify(data.permissions) || []);
        commit('setLoader', false);
        commit('setRole', data.role.name);
        commit('setPermissions', data.permissions || []);
        resolve(data);
      });
    },

      menuSet({ commit }, data ){     
        commit('setLoader', true);
        return new Promise((resolve) => {       
          localStorage.setItem('Menu',  JSON.stringify(data.MenuList) || []);
          commit('setLoader', false);
          commit('setMenu', data.MenuList);
          resolve(data);
        })
      },
      
    },
   
  

  getters: {
    loading(state) {
      return state.loader;
    },
    username(state) {
      return state.username;
    },
    password(state) {
      return state.password;
    },
    errors(state) {
      return state.error;
    },
    token(state) {
      return state.token;
    },
    profile(state) {
      return state.profile;
    },
    drawer(state) {
      return state.drawer;
    },
    notificationDrawer(state) {
      return state.notificationDrawer;
    },    
    getRole(state) {
      return state.role;
    },
    hasPermission: state => permission => {
      return state.permissions.includes(permission);
    },
    getMenu(state) {
      return state.MenuList;
    },

  }
}
